document.addEventListener('DOMContentLoaded', function () {
  const isClampedOverflowing = (contentEl) => {
    const p = contentEl.querySelector('p');
    if (!p) return false;
 
    const width = p.getBoundingClientRect().width;
    if (!width) return false; // not laid out yet
 
    const clone = p.cloneNode(true);
 
    // remove clamp on clone
    clone.style.display = 'block';
    clone.style.overflow = 'visible';
    clone.style.webkitLineClamp = 'unset';
    clone.style.webkitBoxOrient = 'initial';
 
    // keep it in same styling context
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.height = 'auto';
    clone.style.maxHeight = 'none';
    clone.style.width = `${width}px`;
 
    contentEl.appendChild(clone);
    const fullHeight = clone.getBoundingClientRect().height;
    clone.remove();
 
    const clampedHeight = p.getBoundingClientRect().height;
    return fullHeight > clampedHeight + 1;
  };
 
  const updateToggleVisibility = (swiperContainer) => {
    swiperContainer.querySelectorAll('.s2g-review-card').forEach((card) => {
      const content = card.querySelector('.s2g-review-card__content');
      const toggle = card.querySelector('.s2g-review-card__toggle');
      if (!content || !toggle) return;
 
      const overflowing = isClampedOverflowing(content);
      toggle.classList.toggle('is-hidden', !overflowing);
    });
  };

  const initReviewsSwiper = () => {
    const swiperContainer = document.querySelector('.s2g-reviews__swiper');
    if (!swiperContainer) return;

    const prevBtns = Array.from(document.querySelectorAll('.s2g-reviews__nav-btn--prev'));
    const nextBtns = Array.from(document.querySelectorAll('.s2g-reviews__nav-btn--next'));

    const swiper = new Swiper(swiperContainer, {
      loop: true,
      slidesPerView: 1.1,
      centeredSlides: true,
      spaceBetween: 2,
      navigation: {
        nextEl: nextBtns,
        prevEl: prevBtns,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          centeredSlides: true,
          slidesPerView: 'auto',
          slidesPerGroup: 1,
        },
      },
      a11y: {
        prevSlideMessage: 'Previous review',
        nextSlideMessage: 'Next review',
      },
    });

    
    (document.fonts?.ready || Promise.resolve()).then(() => {
      requestAnimationFrame(() => updateToggleVisibility(swiperContainer));
    });

    // Read more/less toggle
    swiperContainer.querySelectorAll('.s2g-review-card__toggle').forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const card = toggle.closest('.s2g-review-card');
        if (!card) return;
        const content = card.querySelector('.s2g-review-card__content');
        if (!content) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        content.classList.toggle('is-expanded', !expanded);
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.textContent = expanded ? 'Read more' : 'Read less';
        swiper.update();
      });
    });
  };

  // Wait for Swiper to be available
  if (typeof Swiper !== 'undefined') {
    initReviewsSwiper();
  } else {
    // Poll for Swiper or check if we loaded it in the liquid file
    const checkSwiper = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkSwiper);
        initReviewsSwiper();
      }
    }, 100);

    // Fallback timeout
    setTimeout(() => {
      clearInterval(checkSwiper);
    }, 10000);
  }
});
